type TUserFrotasRole =
  | 'ADMINISTRADOR'
  | 'ATENDIMENTO'
  | 'COORDENADOR'
  | 'MARKETING'
  | 'FINANCEIRO'
  | 'GERENCIAL'
  | 'COMERCIAL';

type Roles = {
  value: TUserFrotasRole | string;
  id: string;
}[];

export const rolesOptions: Roles = [
  { value: 'ADMINISTRADOR', id: 'ADMINISTRADOR' },
  { value: 'ATENDIMENTO', id: 'ATENDIMENTO' },
  { value: 'COORDENADOR', id: 'COORDENADOR' },
  { value: 'MARKETING', id: 'MARKETING' },
  { value: 'FINANCEIRO', id: 'FINANCEIRO' },
  { value: 'GERENCIAL', id: 'GERENCIAL' },
  { value: 'COMERCIAL', id: 'COMERCIAL' },
];
